import { parsePhoneNumber, PhoneCountryCode } from '@branch-messenger/willow-ui'
import { formatPhoneNumber as willowFormatPhoneNumber } from '@branch-messenger/willow-ui'

export const countryOptions: PhoneCountryCode[] = [
  'US',
  'BM',
  'CA',
  'DO',
  'GU',
  'IN',
  'JM',
  'MX',
  'PR',
  'TT',
  'GB',
  'VI',
]

export const formatPhoneNumber = (phone?: string) => {
  if (!phone) return ''
  return willowFormatPhoneNumber(parsePhoneNumber(phone, 'US')?.number || '')
}
